import { useContext } from 'react';
import { ThemeContext } from '../assets/themes/ThemeProvider';

const useRefreshTheme = () => {
    return useContext(ThemeContext);
};

export default useRefreshTheme;
